var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "list-inline item-touching menu_transaction b-1" },
    _vm._l(_vm.options, function(filter) {
      return _c("li", { key: filter.id }, [
        _c(
          "a",
          {
            class: filter.class,
            on: {
              click: function($event) {
                return _vm.select(filter.id)
              }
            }
          },
          [
            _c("span", { class: filter.chip }),
            _vm._v("\n            " + _vm._s(filter.label) + "\n        ")
          ]
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }